import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { useContentOverflow } from '../../../hooks'
import { FloatingTooltip, FloatingTooltipContentText } from '../../Floating'
import Text from '../../Text'

import * as styles from './ProfileEntityWidgetItemContent.module.css'

function ProfileEntityWidgetItemContent({
  blocked,
  children,
  className = styles.ProfileEntityWidgetItemContent,
  description,
  descriptionClassName = styles.description,
  text,
  textClassName = styles.text,
  onClickTitle,
  onMouseDownTitle,
}) {
  const { t } = useTranslation()

  const isTitleClickable = !blocked && Boolean(onClickTitle)

  const {
    overflow: overflowDescription,
    setContentOverflowRef: setDescriptionContentOverflowRef,
  } = useContentOverflow()

  return (
    <div className={className}>
      <FloatingTooltip
        content={
          <FloatingTooltipContentText
            additionalText={
              isTitleClickable ? t('Common.ClickToOpenProfileKey') : undefined
            }
            text={text}
          />
        }
        placement={FLOATING_ELEMENT_PLACEMENT.top}
      >
        <Text
          className={classNames(textClassName, {
            [styles.notInteractive]: !isTitleClickable,
          })}
          onClick={isTitleClickable ? onClickTitle : undefined}
          onMouseDown={isTitleClickable ? onMouseDownTitle : undefined}
        >
          {text}
        </Text>
      </FloatingTooltip>

      <FloatingTooltip
        content={description}
        disabled={!overflowDescription}
        placement={FLOATING_ELEMENT_PLACEMENT.top}
      >
        <Text
          isSecondary
          className={descriptionClassName}
          ref={setDescriptionContentOverflowRef}
        >
          {description}
        </Text>
      </FloatingTooltip>

      {children}
    </div>
  )
}

export default ProfileEntityWidgetItemContent
